import { FormOutlined as FormOutlinedAntd } from '@ant-design/icons';
import {
  Button as ButtonAntd,
  Input as InputAntd,
  Row as RowAntd,
  Table as TableAntd,
} from 'antd';
import styled from 'styled-components';

export const Content = styled(RowAntd)`
  padding: 20px;

  .color-search-outlined {
    color: #1890ff;
  }
`;

export const IncluirButton = styled(ButtonAntd)`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
`;

export const EditarButton = styled(ButtonAntd)`
  color: #6bbc60;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;

  :hover {
    color: #6bbc60;
  }
`;

export const Table = styled(TableAntd)`
  .ant-table {
    border-right: 1px solid #dfdfdf;
    border-bottom: 1px solid #dfdfdf;
  }

  .ant-table,
  .ant-table-thead > tr > th {
    color: #676a6c;
  }

  .ant-table-thead > tr > th {
    font-weight: 700;
    font-size: 12px;
    height: 44px;
    background: #f5f5f6;
    border: 1px solid #dfdfdf;
  }

  table tr > td {
    padding: 0px 16px;
    font-size: 12px;
    border: 1px solid #e6e6e6;
    background: #ffffff;
    height: 56px;
  }
`;

export const FiltroInput = styled(InputAntd)`
  width: 188px;
  margin-bottom: 8px;
  display: block;
`;

export const FormOutlined = styled(FormOutlinedAntd)`
  font-size: 20px;
`;
